<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-28" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-blue-600 to-blue-700 rounded-xl p-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-xl font-bold">اطلاعات از پیش تعریف شده</h2>
            <p class="text-sm text-blue-50">تکمیل اطلاعات درخواست برگشت داده شده</p>
          </div>
        </div>
      </div>

      <!-- Form Card -->
      <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-6">
        
        <!-- Pre-defined Items -->
        <div v-if="pre_defined_items.length > 0" class="space-y-4">
          <h3 class="text-lg font-bold text-gray-900">ویژگی‌های اضافی</h3>
          
          <div v-for="item in pre_defined_items" :key="item.TextId || item.Id" class="space-y-2">
            
            <!-- Checkbox Items -->
            <div 
              v-if="item.PredefineTypeId == 1" 
              @click="item.IsChecked = !item.IsChecked"
              :class="item.IsChecked ? 'bg-blue-50 border-blue-300' : 'bg-gray-50 border-gray-200'"
              class="flex items-center gap-3 p-3 rounded-lg border cursor-pointer hover:shadow-md transition-all duration-200"
            >
              <div class="flex items-center gap-3 w-full">
                <label class="text-sm font-medium text-gray-900 cursor-pointer">{{ item.Text }}</label>
              </div>
              <div 
                :class="item.IsChecked ? 'bg-blue-600 border-blue-600' : 'bg-white border-gray-300'"
                class="w-6 h-6 border rounded-md flex flex-shrink-0 items-center justify-center transition-all duration-200"
              >
                <svg v-if="item.IsChecked" class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="3" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>

            <!-- Text Input Items -->
            <div v-if="item.PredefineTypeId == 2">
              <label class="block text-sm font-medium text-gray-700 mb-2">{{ item.Text }}</label>
              <input
                v-model="item.Value"
                type="text"
                class="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200"
                style="border: 1px solid #d1d5db !important;"
                :placeholder="item.Text"
              />
            </div>
          </div>
        </div>

        <!-- Empty State -->
        <div v-else class="flex flex-col items-center justify-center py-12">
          <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
            <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <p class="text-gray-500 text-sm">اطلاعات از پیش تعریف شده‌ای یافت نشد</p>
        </div>

      </div>

      <!-- Submit Button -->
      <button 
        @click="go_to_details()"
        class="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white py-4 px-6 rounded-xl font-bold transition-all duration-200 flex items-center justify-center gap-2 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
      >
        {{ $t('add_information') }}
        <svg class="w-5 h-5 rotate-180" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 7l5 5m0 0l-5 5m5-5H6" />
        </svg>
      </button>

    </div>
  </div>
</template>
<script>
  import { bus } from '../../main.js'

  export default {
    props: [
      'passing_data'
    ],
    data () {
      return {
        errors: [],
        price: '',
        branch_id: 0,
        // device_serial_number: '',
        device_password: '',
        pre_defined_items: [],
        request_info: null,

        valid: true,
        not_register: false,
        user_registered: false,

      }
    },
watch: {

    },
mounted () {
this.get_request_info()
    },
    methods: {
      get_request_info() {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          ExpertId: user_id,
          RequestId: this.$route.params.rec_id,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetRequestInfoByReqId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              self.request_info = response.data.rec

              self.get_predifined()

            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

      go_to_details () {
        let text_pre = "";
        const yourlist_type1 = this.pre_defined_items.filter(x => x.PredefineTypeId == 1);
        const yourlist_type2 = this.pre_defined_items.filter(x => x.PredefineTypeId == 2);
        const yourlist_type3 = this.pre_defined_items.filter(x => x.PredefineTypeId == 3);
        const yourlist_type4 = this.pre_defined_items.filter(x => x.PredefineTypeId == 4);

        for (var i = 0; i < yourlist_type1.length; i++) {

          if(yourlist_type1[i].IsChecked){
            text_pre+=(yourlist_type1[i].Text)+("\n");
          }

        }
        for (var i = 0; i < yourlist_type2.length; i++) {

          if(yourlist_type2[i].Value!="" && yourlist_type2[i].Value!=null){
            text_pre+=(yourlist_type2[i].Text)+(" : ")+(yourlist_type2[i].Value)+("\n");
          }

        }

        for (var i = 0; i < yourlist_type3.length; i++) {

          if(yourlist_type3[i].Value!=""){
            text_pre+=(yourlist_type3[i].Text)+(" : ")+(yourlist_type3[i].Value)+("\n");
          }
        }
        this.change_tech_status(text_pre)
      },


      get_predifined () {
        var self = this
        var passing_data = JSON.parse(localStorage.getItem('request_data'))
        var user_id = this.request_info.UserId
        var typeId = this.request_info.PType
        var catId = this.request_info.PCat
        var subcatId = this.request_info.PGrp
        var brandId = this.request_info.PSubGrp
        var DeviceModel = ""

        const send_data = {
          TypeId: typeId,
          CatId: catId,
          GroupId: subcatId,
          BrandId: brandId,
          Model: DeviceModel,
          Phone: DeviceModel,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/PredefinedText', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
self.pre_defined_items = response.data.PredefinedList
            }
          }).catch(e => {
          this.errors.push(e)
        })
      },
      change_tech_status(summary) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId
        const send_data = {
          UserId: user_id,
          ReqId: this.$route.params.rec_id,
          StatusId: 105,
          Desc: summary,
        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/AddChangeStatusByTech', send_data, {})
          .then(response => {
            bus.$emit('show_toast', [2000, response.data.msg])
            self.change_status_dialog = false;
            self.get_request_info()
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

  }
  }
</script>
<style scoped>
  /* Component-specific styles if needed */
</style>
